import { useEffect } from 'react';

import WheelCanvas from '../WheelCanvas';
import { useWheelData } from '@lib/hooks/useWheelData';

const ChoiceCircleWheel = (props) => {
  const {
    streamId, winner, handleWheel, currentRosResult, wheelId, updateWinner,
    type, getCommentsForInteractionWheel,
  } = useWheelData(s => ({
    streamId: s.streamId,
    winner: s.winner,
    handleWheel: s.handleWheel,
    currentRosResult: s.currentRosResult,
    wheelId: s.wheelId,
    updateWinner: s.updateWinner,
    type: s.type,
    getCommentsForInteractionWheel: s.getCommentsForInteractionWheel,
  }));

  useEffect(() => {
    if (currentRosResult?.[0]?.options.length || wheelId) return;
    if (winner === null) return;
    handleWheel({ interactionId: null });
  }, [winner, currentRosResult]);

  useEffect(() => {
    if (!wheelId) return;
    updateWinner();
  }, [wheelId, winner]);

  useEffect(() => {
    getCommentsForInteractionWheel();
  }, []);

  return (
    <>
      <WheelCanvas
        streamId={streamId}
        splitDiv={props.splitDiv}
        playSound={props.playSound}
        layoutMode={props.layoutMode}
        stopFeature={props.stopFeature}
        currentIndex={props.currentIndex}
        isFullScreen={props.isFullScreen}
        playResultSound={props.playResultSound}
        playButtonSound={props.playButtonSound}
        currentRosResult={props.currentRosResult}
        showInstantCustomisationPopup={props.showInstantCustomisationPopup}
      />
    </>
  );
};

export default ChoiceCircleWheel;
